import React, { useState, useEffect } from 'react';
import './result.scss';
import { formatPrice } from '../../Utils/formatting';
import PurchaseService from '../../Data/PurchaseService';
import { Payment, Product, TossReceipt } from 'ai-api/types/purchase';
import { handleLinkClick } from '@/Utils/routing';
import { tLoader } from '@/Utils/i18n';
import { languageManager } from '@/Utils/languageManager';

const translations = {
    en: {
        "Validating your payment...": "Validating your payment...",
        "Payment Error": "Payment Error",
        "Return to Home": "Return to Home",
        "Payment Successful!": "Payment Successful!",
        "Your subscription has been activated successfully.": "Your subscription has been activated successfully.",
        "Your coins have been added to your account.": "Your coins have been added to your account.",
        "Your purchase has been completed successfully.": "Your purchase has been completed successfully.",
        " We've sent a confirmation email with all the details.": " We've sent a confirmation email with all the details.",
        "Order Information": "Order Information",
        "Order ID: ": "Order ID: ",
        "Purchase Details": "Purchase Details",
        "Product:": "Product:",
        "Description:": "Description:",
        "Type:": "Type:",
        "Quantity:": "Quantity:",
        "Total Paid:": "Total Paid:",
        "What's Next?": "What's Next?",
        "Check your email for access details": "Check your email for access details",
        "Your subscription is now active": "Your subscription is now active",
        "Access premium content from your dashboard": "Access premium content from your dashboard",
        "Subscription valid for ": "Subscription valid for ",
        " days": " days",
        " coins have been added to your account": " coins have been added to your account",
        "Use coins to unlock premium content": "Use coins to unlock premium content",
        "Check your balance in your profile": "Check your balance in your profile",
        "Coins never expire": "Coins never expire",
        "Wait for program details": "Wait for program details",
        "Access your purchase from the ": "Access your purchase from the ",
        "history": "history",
        "Contact support if you have any questions": "Contact support if you have any questions",
        "No worries for TOPIK from now!": "No worries for TOPIK from now!",
        "Go to Dashboard": "Go to Dashboard",
        " day access": " day access",
        " days access": " days access",
        " hour access": " hour access",
        " hours access": " hours access",
        " minute session": " minute session",
        " minutes session": " minutes session",
        " coins": " coins",
        "Digital product": "Digital product",
        "Service": "Service"
    },
    id: {
        "Validating your payment...": "Memvalidasi pembayaran Anda...",
        "Payment Error": "Kesalahan Pembayaran",
        "Return to Home": "Kembali ke Beranda",
        "Payment Successful!": "Pembayaran Berhasil!",
        "Your subscription has been activated successfully.": "Langganan Anda telah diaktifkan dengan sukses.",
        "Your coins have been added to your account.": "Koin Anda telah ditambahkan ke akun Anda.",
        "Your purchase has been completed successfully.": "Pembelian Anda telah selesai dengan sukses.",
        " We've sent a confirmation email with all the details.": " Kami telah mengirimkan email konfirmasi dengan semua detail.",
        "Order Information": "Informasi Pesanan",
        "Order ID: ": "ID Pesanan: ",
        "Purchase Details": "Detail Pembelian",
        "Product:": "Produk:",
        "Description:": "Deskripsi:",
        "Type:": "Tipe:",
        "Quantity:": "Kuantitas:",
        "Total Paid:": "Total Dibayar:",
        "What's Next?": "Apa Selanjutnya?",
        "Check your email for access details": "Periksa email Anda untuk detail akses",
        "Your subscription is now active": "Langganan Anda sekarang aktif",
        "Access premium content from your dashboard": "Akses konten premium dari dasbor Anda",
        "Subscription valid for ": "Langganan berlaku untuk ",
        " days": " hari",
        " coins have been added to your account": " koin telah ditambahkan ke akun Anda",
        "Use coins to unlock premium content": "Gunakan koin untuk membuka konten premium",
        "Check your balance in your profile": "Periksa saldo Anda di profil Anda",
        "Coins never expire": "Koin tidak pernah kedaluwarsa",
        "Wait for program details": "Tunggu detail program",
        "Access your purchase from the ": "Akses pembelian Anda dari ",
        "history": "riwayat",
        "Contact support if you have any questions": "Hubungi dukungan jika Anda memiliki pertanyaan",
        "No worries for TOPIK from now!": "Tidak perlu khawatir tentang TOPIK mulai sekarang!",
        "Go to Dashboard": "Ke Dasbor",
        " day access": " hari akses",
        " days access": " hari akses",
        " hour access": " jam akses",
        " hours access": " jam akses",
        " minute session": " menit sesi",
        " minutes session": " menit sesi",
        " coins": " koin",
        "Digital product": "Produk digital",
        "Service": "Layanan"
    },
    ko: {
        "Validating your payment...": "결제를 확인하는 중...",
        "Payment Error": "결제 오류",
        "Return to Home": "홈으로 돌아가기",
        "Payment Successful!": "결제 성공!",
        "Your subscription has been activated successfully.": "구독이 성공적으로 활성화되었습니다.",
        "Your coins have been added to your account.": "코인이 계정에 추가되었습니다.",
        "Your purchase has been completed successfully.": "구매가 성공적으로 완료되었습니다.",
        " We've sent a confirmation email with all the details.": " 모든 세부 정보가 포함된 확인 이메일을 보냈습니다.",
        "Order Information": "주문 정보",
        "Order ID: ": "주문 번호: ",
        "Purchase Details": "구매 세부정보",
        "Product:": "제품:",
        "Description:": "설명:",
        "Type:": "유형:",
        "Quantity:": "수량:",
        "Total Paid:": "총 결제액:",
        "What's Next?": "다음 단계는?",
        "Check your email for access details": "이메일에서 액세스 세부정보를 확인하세요",
        "Your subscription is now active": "구독이 활성화되었습니다",
        "Access premium content from your dashboard": "대시보드에서 프리미엄 콘텐츠에 액세스하세요",
        "Subscription valid for ": "구독 유효 기간: ",
        " days": "일",
        " coins have been added to your account": "코인이 계정에 추가되었습니다",
        "Use coins to unlock premium content": "코인을 사용하여 프리미엄 콘텐츠 잠금 해제",
        "Check your balance in your profile": "프로필에서 잔액 확인",
        "Coins never expire": "코인은 만료되지 않습니다",
        "Wait for program details": "프로그램 세부정보 대기",
        "Access your purchase from the ": "구매 내역은 ",
        "history": "히스토리",
        "Contact support if you have any questions": "질문이 있으시면 지원팀에 문의하세요",
        "No worries for TOPIK from now!": "이제 TOPIK 걱정 없어요!",
        "Go to Dashboard": "대시보드로 이동",
        " day access": "일 액세스",
        " days access": "일 액세스",
        " hour access": "시간 액세스",
        " hours access": "시간 액세스",
        " minute session": "분 세션",
        " minutes session": "분 세션",
        " coins": " 코인",
        "Digital product": "디지털 제품",
        "Service": "서비스"
    },
    vn: {
        "Validating your payment...": "Đang xác thực thanh toán của bạn...",
        "Payment Error": "Lỗi Thanh toán",
        "Return to Home": "Quay lại Trang chủ",
        "Payment Successful!": "Thanh toán Thành công!",
        "Your subscription has been activated successfully.": "Đăng ký của bạn đã được kích hoạt thành công.",
        "Your coins have been added to your account.": "Tiền xu của bạn đã được thêm vào tài khoản.",
        "Your purchase has been completed successfully.": "Mua hàng của bạn đã hoàn tất thành công.",
        " We've sent a confirmation email with all the details.": " Chúng tôi đã gửi email xác nhận với tất cả thông tin chi tiết.",
        "Order Information": "Thông tin Đơn hàng",
        "Order ID: ": "Mã Đơn hàng: ",
        "Purchase Details": "Chi tiết Mua hàng",
        "Product:": "Sản phẩm:",
        "Description:": "Mô tả:",
        "Type:": "Loại:",
        "Quantity:": "Số lượng:",
        "Total Paid:": "Tổng Thanh toán:",
        "What's Next?": "Tiếp theo là gì?",
        "Check your email for access details": "Kiểm tra email của bạn để biết chi tiết truy cập",
        "Your subscription is now active": "Đăng ký của bạn hiện đang hoạt động",
        "Access premium content from your dashboard": "Truy cập nội dung cao cấp từ bảng điều khiển của bạn",
        "Subscription valid for ": "Đăng ký có hiệu lực trong ",
        " days": " ngày",
        " coins have been added to your account": " tiền xu đã được thêm vào tài khoản của bạn",
        "Use coins to unlock premium content": "Sử dụng tiền xu để mở khóa nội dung cao cấp",
        "Check your balance in your profile": "Kiểm tra số dư của bạn trong hồ sơ",
        "Coins never expire": "Tiền xu không bao giờ hết hạn",
        "Wait for program details": "Chờ chi tiết chương trình",
        "Access your purchase from the ": "Truy cập mua hàng của bạn từ ",
        "history": "lịch sử",
        "Contact support if you have any questions": "Liên hệ hỗ trợ nếu bạn có bất kỳ câu hỏi nào",
        "No worries for TOPIK from now!": "Không lo lắng về TOPIK từ bây giờ!",
        "Go to Dashboard": "Đi đến Bảng điều khiển",
        " day access": " ngày truy cập",
        " days access": " ngày truy cập",
        " hour access": " giờ truy cập",
        " hours access": " giờ truy cập",
        " minute session": " phút buổi học",
        " minutes session": " phút buổi học",
        " coins": " tiền xu",
        "Digital product": "Sản phẩm kỹ thuật số",
        "Service": "Dịch vụ"
    }
};

const PaymentSuccess: React.FC = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const orderid = queryParams.get('orderid');
    const productid = queryParams.get('productid');
    const paymentKey = queryParams.get('paymentKey');
    const amount = queryParams.get('amount');

    const [loading, setLoading] = useState(true);
    const [payment, setPayment] = useState<Payment | null>(null);
    const [product, setProduct] = useState<Product | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [, forceUpdate] = useState({});
    const t = tLoader(translations);

    useEffect(() => {
        const unsubscribe = languageManager.subscribe(() => forceUpdate({}));
        return unsubscribe;
    }, []);

    useEffect(() => {
        if (productid) {
            const fetchProduct = async () => {
                try {
                    const productResponse = await PurchaseService.getProduct(productid);
                    const productData = productResponse.data || productResponse;
                    setProduct(productData);
                } catch (error) {
                    console.error('Failed to fetch product info:', error);
                }
            };
            fetchProduct();
        }
    }, [productid]);

    useEffect(() => {
        const validateTossPayment = async () => {
            try {
                const receipt: TossReceipt = {
                    paymentKey: paymentKey!,
                    orderId: orderid!,
                    amount: parseInt(amount!)
                };

                const response = await PurchaseService.validateTossPayment(orderid!, productid, receipt);

                if (response?.code === 200 && response?.data?.valid) {
                    await fetchPaymentInfo();
                } else {
                    setError('Payment validation failed');
                    setLoading(false);
                }
            } catch (error) {
                console.error('Failed to validate Toss payment:', error);
                setError('Failed to validate payment');
                setLoading(false);
            }
        };

        const fetchPaymentInfo = async () => {
            try {
                const response = await PurchaseService.getPayment(orderid!);

                if (response?.code === 200 && response?.data?.length > 0) {
                    const paymentData = response.data[0];
                    setPayment(paymentData);

                    if (paymentData.status !== 'succeeded') {
                        setError(`Payment status: ${paymentData.status}`);
                        setLoading(false);
                        return;
                    }

                    setLoading(false);
                } else {
                    setError('Payment not found');
                    setLoading(false);
                }
            } catch (error) {
                console.error('Failed to fetch payment info:', error);
                setError('Failed to load payment information');
                setLoading(false);
            }
        };

        const debounceTimer = setTimeout(() => {
            if (orderid && paymentKey && amount) {
                validateTossPayment();
            } else if (orderid) {
                fetchPaymentInfo();
            } else {
                setError('Invalid payment information');
                setLoading(false);
            }
        }, 200);

        return () => clearTimeout(debounceTimer);
    }, [orderid, paymentKey, amount, productid]);


    const getProductTypeDescription = (type: string, value: number) => {
        switch (type) {
            case 'subscription':
                const days = Math.floor(value / 86400);
                const hours = Math.floor((value % 86400) / 3600);
                const minutes = Math.floor((value % 3600) / 60);
                if (days > 0) return `${days}${t(days > 1 ? " days access" : " day access")}`;
                if (hours > 0) return `${hours}${t(hours > 1 ? " hours access" : " hour access")}`;
                return `${minutes}${t(minutes > 1 ? " minutes session" : " minute session")}`;
            case 'coin':
                return `${value}${t(" coins")}`;
            case 'product':
                return t('Digital product');
            default:
                return t('Service');
        }
    };

    if (loading) {
        return (
            <div className="payment-result-loading">
                <div className="loading-container">
                    <div className="loading-spinner"></div>
                    <p className="loading-text">{t("Validating your payment...")}</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="payment-result-container">
                <div className="payment-result-content">
                    <h2 className="title error">{t("Payment Error")}</h2>
                    <div className="result-icon">
                        <svg viewBox="0 0 24 24" width="64" height="64">
                            <circle cx="12" cy="12" r="11" fill="#f44336" stroke="white" strokeWidth="2" />
                            <path d="M8 8l8 8M16 8l-8 8" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </div>
                    <p className="result-message">{error}</p>
                    <div className="section-action">
                        <a href="/" className="button secondary">{t("Return to Home")}</a>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="payment-result-container">
            <div className="payment-result-content">
                <h2 className="title success">{t("Payment Successful!")}</h2>

                <div className="result-icon">
                    <svg viewBox="0 0 24 24" width="64" height="64">
                        <circle cx="12" cy="12" r="11" fill="#4CAF50" stroke="white" strokeWidth="2" />
                        <path d="M7 13l3 3 7-7" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>

                <p className="result-message">
                    {payment?.type === 'subscription'
                        ? t("Your subscription has been activated successfully.")
                        : payment?.type === 'coin'
                        ? t("Your coins have been added to your account.")
                        : t("Your purchase has been completed successfully.")}
                    {t(" We've sent a confirmation email with all the details.")}
                </p>

                <div className="section">
                    <h2 className="section-title">{t("Order Information")}</h2>
                    <div className="section-content">
                        {payment?.orderid && (
                            <div className="order-id">
                                {t("Order ID: ")}{payment.orderid}
                            </div>
                        )}
                    </div>
                </div>

                <div className="section">
                    <h2 className="section-title">{t("Purchase Details")}</h2>
                    <div className="section-content">
                        {product && (
                            <>
                                <div className="summary-item">
                                    <span className="label">{t("Product:")}</span>
                                    <span className="value">{product.name}</span>
                                </div>
                                {product.detail && (
                                    <div className="summary-item">
                                        <span className="label">{t("Description:")}</span>
                                        <span className="value">{product.detail}</span>
                                    </div>
                                )}
                                <div className="summary-item">
                                    <span className="label">{t("Type:")}</span>
                                    <span className="value">
                                        {getProductTypeDescription(product.type, product.value)}
                                    </span>
                                </div>
                            </>
                        )}
                        {payment && (
                            <>
                                {payment.quantity > 1 && (
                                    <div className="summary-item">
                                        <span className="label">{t("Quantity:")}</span>
                                        <span className="value">{payment.quantity}</span>
                                    </div>
                                )}
                                <div className="summary-item">
                                    <span className="label">{t("Total Paid:")}</span>
                                    <span className="value">
                                        {formatPrice(payment.finalAmount, payment.currency)}
                                    </span>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <div className="section">
                    <h2 className="section-title">{t("What's Next?")}</h2>
                    <div className="section-content">
                        {payment?.type === 'subscription' ? (
                            <ul>
                                <li>{t("Check your email for access details")}</li>
                                <li>{t("Your subscription is now active")}</li>
                                <li>{t("Access premium content from your dashboard")}</li>
                                {payment.remainder && (
                                    <li>{t("Subscription valid for ")}{Math.floor(payment.remainder / 86400)}{t(" days")}</li>
                                )}
                            </ul>
                        ) : payment?.type === 'coin' ? (
                            <ul>
                                <li>{payment.value}{t(" coins have been added to your account")}</li>
                                <li>{t("Use coins to unlock premium content")}</li>
                                <li>{t("Check your balance in your profile")}</li>
                                <li>{t("Coins never expire")}</li>
                            </ul>
                        ) : (
                            <ul>
                                <li>{t("Wait for program details")}</li>
                                <li>{t("Access your purchase from the ")}<a href="/purchase/history" onClick={handleLinkClick}>{t("history")}</a></li>
                                <li>{t("Contact support if you have any questions")}</li>
                                <li>{t("No worries for TOPIK from now!")}</li>
                            </ul>
                        )}
                    </div>
                </div>

                <div className="section-action">
                    <a href="/" className="button secondary">
                        {t("Return to Home")}
                    </a>
                    {payment?.type === 'subscription' && (
                        <a href="/dashboard" className="button primary">
                            {t("Go to Dashboard")}
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess;